import applications from "./timesheets";

export const TIMESHEETS_NAMESPACE = "timesheets";

export default applications;
